var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLevel5 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21.533,
  height: 17.49
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "level5_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.533v17.49H0z",
  "data-name": "Rectangle 18369"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#level5_svg__a)",
  "data-name": "Group 644065"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.533 2H10.117a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647976"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.533 5.872H10.117a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647977"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.533 9.745H10.117a1 1 0 1 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647978"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.533 13.618H10.117a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647979"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#772432",
  d: "M20.533 17.49H10.117a1 1 0 0 1 0-2h10.416a1 1 0 0 1 0 2",
  "data-name": "Path 647980"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#004165",
  d: "M5.789 4.515h-3.1L2.33 7.06a3 3 0 0 1 .394-.018 3.7 3.7 0 0 1 2.2.878 3.56 3.56 0 0 1 .985 2.671A3.76 3.76 0 0 1 2.1 14.642a4.5 4.5 0 0 1-2.1-.484l.34-1.524a3.66 3.66 0 0 0 1.649.43 2.033 2.033 0 0 0 2.043-2.294c0-1.7-1.147-2.33-2.58-2.33a5.6 5.6 0 0 0-.861.054l.681-5.646h4.517Z",
  "data-name": "Path 647981"
}))));
export { SvgLevel5 as ReactComponent };
export default __webpack_public_path__ + "6185701868dc7bce3b96328d13280e50.svg";